<template>
    <div :id="id" class="hide" v-if="enabledLanguages.length > 0">
        <div class="row-item">
            <ul>
                <li class="row-span" v-for="(language, l) in enabledLanguages" :key="l"><a :id="language" class="btn" @click="$emit('select-language', $event)">{{language}}</a></li>
            </ul>
        </div>
    </div>
</template>

<script>
import { ASSETS } from '@/assets/js/assets.js'
export default {
    name: 'LanguageSelectionMenu',
    props: { id: String },
    data: () => ({ enabledLanguages: [] }),
    mounted() { ASSETS.LanguageSelection.State(this); }
}
</script>